module.exports = __webpack_public_path__ + "img/dr-pino-and-family.8b9df4c2.jpeg";